module.exports = __webpack_public_path__ + "img/IMG_0480.d5b023e7.jpg";